import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React from 'react';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { bazImageMobileUrl, bazImageUrl } from 'reactApp/sections/SubscriptionsPage/ui/CreditCard/CreditCard.helpers';
import unlinkCardModalStyles from 'reactApp/ui/UnlinkCardConfirmModal/UnlinkCardConfirmModal.css';

import styles from './CardUnlinkBazModalContent.css';

interface BazModalHeaderProps {
    bazSizeFormatted: string;
    isOverBaseQuotaWithBaz: boolean;
}

export const BazModalHeader = ({ bazSizeFormatted, isOverBaseQuotaWithBaz }: BazModalHeaderProps) => {
    const isMobile = EnvironmentSelectors.isMobile();
    return (
        <div className={classNames(styles.bazHeader, { [styles.bazHeaderMobile]: isMobile })}>
            {isMobile && <Spacing size={292} />}
            <img
                className={classNames(styles.bazImage, { [styles.bazImageMobile]: isMobile })}
                src={isMobile ? bazImageMobileUrl : bazImageUrl}
                alt="Безлимитная загрузка"
            />
            <div className={classNames({ [styles.bazTitleMobile]: isMobile })}>
                Без карты <span className={unlinkCardModalStyles.negative}>{bazSizeFormatted}</span>{' '}
                {isOverBaseQuotaWithBaz ? 'файлов может не хватить места' : 'файлов займут место в Облаке'}
            </div>
            {isMobile && <Spacing size={8} />}
        </div>
    );
};

interface BazModalContentProps {
    isOverBaseQuotaWithBaz: boolean;
}

export const BazModalContent = ({ isOverBaseQuotaWithBaz }: BazModalContentProps) => {
    const isMobile = EnvironmentSelectors.isMobile();
    return (
        <p className={classNames(unlinkCardModalStyles.text, { [styles.bazContentMobile]: isMobile })}>
            {isOverBaseQuotaWithBaz
                ? 'Эти файлы загружены с безлимитом и не занимают место в пространстве, если подписка не продлится - займут. Им не хватит 8 бесплатных ГБ, поэтому в Облаке и Почте появятся ограничения'
                : 'Сейчас эти файлы не занимают место, потому что загружены с безлимитом. Если подписка не продлится, для них и остальных файлов останется 8 базовых ГБ'}
        </p>
    );
};
